import { forwardRef } from 'react';

import { ChipProps, StyledChip } from './Chip.styled';

export const Chip = forwardRef<HTMLDivElement, ChipProps>(({ size = 'small', ...rest }, ref) => (
  <StyledChip ref={ref} size={size} {...rest} />
));

Chip.displayName = 'Chip';
